// Header scroll behavior - hide/show on scroll direction + is-scrolled for homepage background color
class HeaderScroll {
  constructor() {
    this.header = document.querySelector('.header');
    this.heroContainer = document.querySelector('.hero-container');
    this.lastScrollY = 0;
    this.scrollThreshold = 50; // Minimum scroll distance before hiding
    
    // Track scroll direction history for iOS momentum scrolling
    this.scrollHistory = [];
    this.historySize = 3;
    this.lastKnownDirection = 'down';
    
    // Check for homepage templates that use is-scrolled (for background color only)
    this.isHomepage = document.body.classList.contains('template-index') || 
                      document.body.classList.contains('template--index');
    
    if (this.header) {
      this.init();
    }
  }

  init() {
    // Check scroll position on load
    this.lastScrollY = window.scrollY;
    
    // On initial load, if already scrolled, hide header
    if (window.scrollY > this.scrollThreshold) {
      this.header.classList.add('is-scrolling-down');
    }
    
    this.checkScroll();

    // Check scroll position on scroll
    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => this.checkScroll());
    });
    
    // Check scroll position on resize
    window.addEventListener('resize', () => {
      this.checkScroll();
    });
  }

  getScrollDirection() {
    // For iOS, use a more reliable scroll direction detection
    // by tracking scroll history instead of just comparing two values
    const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    
    // Add current position to history
    this.scrollHistory.push({
      position: scrollPosition,
      time: Date.now()
    });
    
    // Keep only recent history
    if (this.scrollHistory.length > this.historySize) {
      this.scrollHistory.shift();
    }
    
    // Calculate direction based on history (more reliable for iOS)
    if (this.scrollHistory.length >= 2) {
      const first = this.scrollHistory[0];
      const last = this.scrollHistory[this.scrollHistory.length - 1];
      const delta = last.position - first.position;
      
      // Only update direction if there's a meaningful change
      if (Math.abs(delta) > 2) {
        this.lastKnownDirection = delta > 0 ? 'down' : 'up';
      }
    }
    
    // Fallback to immediate comparison for initial detection
    if (scrollPosition > this.lastScrollY) {
      this.lastKnownDirection = 'down';
    } else if (scrollPosition < this.lastScrollY) {
      this.lastKnownDirection = 'up';
    }
    
    return this.lastKnownDirection;
  }

  checkScroll() {
    const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const scrollDirection = this.getScrollDirection();
    const scrollDelta = Math.abs(scrollPosition - this.lastScrollY);

    // Update is-scrolled class for homepage (background color change only)
    if (this.isHomepage && this.heroContainer) {
      const heroBottom = this.heroContainer.offsetHeight;
      if (scrollPosition > heroBottom) {
        this.header.classList.add('is-scrolled');
      } else {
        this.header.classList.remove('is-scrolled');
      }
    }
    
    // Unified hide/show behavior for all pages
    if (scrollDelta > 5) {
      if (scrollDirection === 'down' && scrollPosition > this.scrollThreshold) {
        // Scrolling down past threshold - hide header
        this.header.classList.add('is-scrolling-down');
        this.header.classList.remove('is-scrolling-up');
      } else if (scrollDirection === 'up') {
        // Scrolling up - show header
        this.header.classList.add('is-scrolling-up');
        this.header.classList.remove('is-scrolling-down');
      }
    }

    this.lastScrollY = scrollPosition;
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  new HeaderScroll();
});

